/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratCommentInfo,
    JsonStratCommentInfoFromJSON,
    JsonStratCommentInfoFromJSONTyped,
    JsonStratCommentInfoToJSON,
} from './JsonStratCommentInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonStratCommentInfo
 */
export interface ApiResultOfJsonStratCommentInfo {
    /**
     * 
     * @type {JsonStratCommentInfo}
     * @memberof ApiResultOfJsonStratCommentInfo
     */
    data?: JsonStratCommentInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratCommentInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonStratCommentInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratCommentInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratCommentInfo
     */
    result?: ApiResultOfJsonStratCommentInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonStratCommentInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonStratCommentInfoFromJSON(json: any): ApiResultOfJsonStratCommentInfo {
    return ApiResultOfJsonStratCommentInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonStratCommentInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonStratCommentInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonStratCommentInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonStratCommentInfoToJSON(value?: ApiResultOfJsonStratCommentInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonStratCommentInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

